;(function () {
  angular
    .module('contrast.org.dashboard')
    .controller('DashboardVulnerabilitiesCtrl', DashboardVulnerabilitiesCtrl)

  function DashboardVulnerabilitiesCtrl(
    $scope,
    $routeSegment,
    ErrorService,
    ChartService,
    LoadFilterRouteService,
    PromiseService,
    ScoreFactory,
    orgTraceApiConfig,
    csVulnerabilityViolationsService,
    TRACE_BREAKDOWN_TYPES,
    VULNERABILITY_REPORT_RANGES_DASHBOARD,
    VULNERABILITY_REPORT_TYPE,
    SUBFILTERS
  ) {
    'ngInject'

    var lastSearch

    function init() {
      getThermometerData()
      getRemediationPolicyViolations()
      _getGraphData()
    }

    angular.extend($scope, {
      thermometer: {
        breakdowns: TRACE_BREAKDOWN_TYPES,
        breakdown: TRACE_BREAKDOWN_TYPES[0],
        data: []
      },
      vulnTrendChartTimeRangeStr: 'week',
      vulnTrendChartData: {
        loaded: false,
        closed: [],
        open: []
      },
      select: {
        ranges: VULNERABILITY_REPORT_RANGES_DASHBOARD
      },
      model: {
        range: VULNERABILITY_REPORT_RANGES_DASHBOARD[0]
      },

      orgUuid: $routeSegment.$routeParams.orgUuid
    })

    angular.extend($scope, {
      changeRange: _getGraphData,
      onThermometerBreakdownChange: function () {
        getThermometerData()
      },
      onThermometerClick: function (record) {
        if (record.link) {
          if (record.type == 'vuln') {
            var filters = {}

            switch (record.breakdown) {
              case 'Severity':
                filters[SUBFILTERS.VULNS.ENUM.SEVERITY] = [
                  record.keycode.toUpperCase()
                ]
                filters[SUBFILTERS.VULNS.ENUM.STATUS] = [
                  'Reported',
                  'Suspicious',
                  'Confirmed'
                ]
                LoadFilterRouteService.goToOrganizationVulnerabilities(filters)
                break

              case 'Status':
                filters[SUBFILTERS.VULNS.ENUM.STATUS] = [record.keycode]
                LoadFilterRouteService.goToOrganizationVulnerabilities(filters)
                break

              case 'Type':
                filters[SUBFILTERS.VULNS.ENUM.VULNTYPE] = [record.keycode]
                filters[SUBFILTERS.VULNS.ENUM.STATUS] = [
                  'Reported',
                  'Suspicious',
                  'Confirmed'
                ]
                LoadFilterRouteService.goToOrganizationVulnerabilities(filters)
                break

              default:
                break
            }
          }
        }
      },
      goToOpenVulns: function () {
        var filters = {}
        filters[SUBFILTERS.VULNS.ENUM.STATUS] = [
          'Reported',
          'Suspicious',
          'Confirmed'
        ]
        LoadFilterRouteService.goToOrganizationVulnerabilities(filters)
      }
    })

    function getThermometerData() {
      var promise = null,
        breakdown = $scope.thermometer.breakdown

      switch (breakdown) {
        case 'Severity':
          promise = ScoreFactory.getTraceBreakdownBySeverity()
          break

        case 'Status':
          promise = ScoreFactory.getTraceBreakdownByStatus()
          break

        case 'Type':
          promise = ScoreFactory.getTraceBreakdownByRule()
          break

        default:
          break
      }

      promise.then(
        function (response) {
          $scope.thermometer.data = ChartService.buildTraceThermometerData(
            breakdown,
            response.data
          )
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function getRemediationPolicyViolations() {
      csVulnerabilityViolationsService
        .getViolations()
        .then(function (violations) {
          $scope.violations = violations
        })
    }

    function _getGraphData() {
      if (lastSearch) {
        PromiseService.cancelPromise(lastSearch)
      }
      if ($scope.model.range.group == 'New') {
        $scope.vulnTrendChartType = VULNERABILITY_REPORT_TYPE.NEW
        lastSearch = orgTraceApiConfig.getNewTrendData(
          $scope.model.range.keycode
        )
      } else {
        $scope.vulnTrendChartType = VULNERABILITY_REPORT_TYPE.TOTAL
        lastSearch = orgTraceApiConfig.getTotalTrendData(
          $scope.model.range.keycode
        )
      }

      return lastSearch.then(
        function (response) {
          $scope.vulnTrendChartData.closed = response.data.closed
          $scope.vulnTrendChartData.open = response.data.open
          $scope.vulnTrendChartData.loaded = true
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    init()
  }
})()
